import api from "./";

export const transformaMovimentos = (caminho, url, obj = {}) =>
    api.post(`/transformaMovimentos/${caminho}/?${url.toString()}`, obj);
